<template>
    <div id="chat-form-wrapper">
        <v-form id="post-message" model="valid" @submit.prevent="handlePostMessage">
            <v-textarea 
                type="input"
                v-model="message"
                rows="1"
                auto-grow
                append-inner-icon="mdi-send"
                variant="solo"
                :maxlength="1000"
                :placeholder="$t('TEXT_ENTRY_PLACEHOLDER')"
                :disabled="disableInput"
                @click:append-inner="handlePostMessage"
                @keydown="handleKeydown"
            ></v-textarea>
        </v-form>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from "vuex";

    export default {
        name: 'ChatForm',
        data: () => ({
            valid: false,
            message: '',
            messageRules: [
                value => {
                    if (value) return true;
                }
            ]
        }),
        mounted() {
            if (this.messageDraft) {
                this.message = this.messageDraft;
            }
        },
        computed: {
            ...mapGetters([
                "currentChat",
                "currentChatId",
                "messageDraft",
                "ratingPending",
                "responsePending",
                "escalationPending",
            ]),
            disableInput() {
                return this.isClosed || this.responsePending || this.ratingPending || this.escalationPending;
            },
            isClosed() {
                return this.currentChat?.isOpen === false || false;
            },
        },
        methods: {
            ...mapActions(["postChatMessage"]),
            handleKeydown(e) {
                if (e.key === 'Enter' && !e.shiftKey) {
                    this.handlePostMessage(e);
                }
            },
            async handlePostMessage(e) {
                e.preventDefault();

                this.message = this.message.trim();
                if (!this.message) {
                    return false;
                }

                const postMessageInput = {
                    chatId: parseInt(this.currentChatId),
                    message: this.message,
                }

                this.message = '';

                const result = await this.postChatMessage(postMessageInput);

                if (result === false) {
                    this.message = this.messageDraft;
                }
            },
        },
    
    }
</script>